import { HeaderDesktop } from './components/HeaderDesktop';
import { HeaderMobile } from './components/HeaderMobile';
import { HeaderLayoutProps } from './types';

export const HeaderLayout = ({ isDesktop, ...props }: HeaderLayoutProps) =>
  // @ts-expect-error TODO-JS
  isDesktop ? <HeaderDesktop {...props} /> : <HeaderMobile {...props} />;
